import axios from 'axios'

$(() => {
  const $select = $('.js-csv-download-month-select')

  if (!$select.length) {
    return
  }

  $select.each(function() {
    const $currentSelect = $(this)
    const $currentList = $currentSelect.closest('.modal-body').find('.js-csv-download-modal-file-list')
    // 抽出基準(ライフソムリエールの予約CSVのみ)
    const $currentBase = $currentSelect.closest('.modal-body').find('.js-csv-download-base')

    const loadFiles = async () => {
      try {
        const model = $currentSelect.data('model')
        const targetMonth = $currentSelect.val()

        $currentList.html(`
          <div class="text-left mb-3">
            読み込み中...
          </div>
        `)

        const params = {
          model: model,
          month: targetMonth
        }
        if ($currentBase.length) {
          params.base = $currentBase.filter(':checked').val()
        }
        const { data } = await axios.get("/owner/csv_download/list", { params })
        console.log(data)

        if (data.length === 0) {
          $currentList.html(`
            <div class="text-left mb-3">
              データが存在しません
            </div>
          `)

          return
        }

        const html = data.map(file => `
          <div class="d-flex align-items-center mb-3">
            <span>${file.label}</span>
            <a href="${file.url}" class="btn btn-default ml-auto py-1 px-3">
              <i class="fal fa-arrow-to-bottom f14 mr-1"></i>
              <span class="f12">ダウンロード</span>
            </a>
          </div>
        `).join('')

        $currentList.html(html)
      } catch (error) {
        console.error('CSVダウンロード一覧取得エラー', error)

        $currentList.html(`
          <div class="text-left text-danger mb-3">
            データの取得中に失敗しました。<br>しばらくしてから再度お試しください。
          </div>
        `)
      }
    }

    $select.on('change', loadFiles)
    $currentBase.on('change', loadFiles)

    // 初期表示
    loadFiles()
  })
})
